import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogUiRedesign/DialogHeader';
import { I18Text } from '../../../../../components/i18Next/I18Text';

import styles from './RequestPOCView.module.scss';

interface RequestPOCViewProps {
  cardNumberEnding: string;
  onClose: () => void;
  onContactSupport: () => void;
  onOk: () => void;
}

export function RequestPOCView(props: RequestPOCViewProps) {
  const { onClose, onOk, onContactSupport, cardNumberEnding } = props;
  const { t } = useTranslation();
  return createPortal(
    <div className={styles.parent}>
      <div className={classNames(styles.dialog)}>
        <DialogHeader title={t('poc.cardVerification')} titleClassName={styles.title} onClose={onClose} />
        <DialogContent>
          <div className={styles.textWrapper}>
            <I18Text
              className={styles.textBig}
              components={{ regular: <span className={styles.textSmall} /> }}
              i18nKey="poc.pleaseCompleteVerificationPrefixV2"
              values={{
                cardNumberEnding,
              }}
            />
          </div>
          <div className={styles.buttonsWrapper}>
            <Button btnType="main" className={styles.btn} onClick={onOk}>
              {t('poc.letsDoIt')}
            </Button>
            <Button btnType="purple" className={styles.btn} onClick={onContactSupport}>
              {t('common.contactSupport')}
            </Button>
          </div>
        </DialogContent>
      </div>
    </div>,
    document.body,
  );
}
